<template>
	<div class="panel panel-default">
	  <div class="panel-heading">
	    <h2 class="panel-title">
	      <span id="name">
	        {{ myhosp.name }}
	      </span>
	    </h2>
	  </div>
	  <div class="panel-body">
	    <!-- Year -->
	      <div class="row" v-if="props.showyear == true">
	        <div class="col-sm-6 text-right">
	          <strong>Data Year:</strong>
	        </div>
	        <div class="col-sm-6">
	          <select  name="myhosp_year" id="myhosp_year" onchange="hospitalAjax();" @change="updateMyHosp"  v-model="myhosp_year">
	            <option  v-for="(year) in years" :key="year" :value="year"> {{ year }}
							</option>
	          </select>
	        </div>
	      </div>
	  
	    <!-- CAHFIR ID -->
	    <div class="row">
	      <div class="col-sm-6 text-right">
	      <strong>CAHFIR #:</strong>
	      </div>
	      <div class="col-sm-6">
	        <span id="cahid">
	          <div class="col-sm-6" v-if="myhosp.cahid == ''">
	          	<span class="missingdata">MISSING DATA</span>
	          </div>
	        <div v-else>
	          {{ myhosp.cahid }}
	        </div>
	        </span>
	      </div>
	    </div>
	    <!-- CMS ID -->
	    <div class="row">
	      <div class="col-sm-6 text-right">
	        <strong>CMS ID:</strong>
	      </div>
	      <div class="col-sm-6">
	        <div class="col-sm-6" v-if="myhosp.cmsid == ''">
	          <span class="missingdata">MISSING DATA</span>
	        </div>
	        <div v-else>
	          {{ myhosp.cmsid }}
	        </div>
	      </div>
	    </div>
	    <!-- Region -->
	    <div class="row">
	      <div class="col-sm-6 text-right">
	        <strong>Region:</strong>
	      </div>
	      <div class="col-sm-6">
	        <div class="col-sm-6" v-if="myhosp.regname == ''">
	          <span class="missingdata">MISSING DATA</span>
	        </div>
	        <div v-else>
	          {{ myhosp.regname }}
	        </div>
	      </div>
	    </div>
	    <!-- State -->
	    <div class="row">
	      <div class="col-sm-6 text-right">
	        <strong>State:</strong>
	      </div>
	      <div class="col-sm-6">
	        <div class="col-sm-6" v-if="myhosp.cahstate == ''">
	          <span class="missingdata">MISSING DATA</span>
	        </div>
	        <div v-else>
	          {{ myhosp.cahstate }}
	        </div>
	      </div>
	    </div>
	    <!-- Net Patient Revenue -->
	    <div class="row">
	      <div class="col-sm-6 text-right">
	        <strong>Net Patient Revenue:</strong>
	      </div>
	      <div class="col-sm-6">
	        <div class="col-sm-6" v-if="myhosp.revcat == ''">
	          <span class="missingdata">MISSING DATA</span>
	        </div>
	        <div v-else>
	          {{ myhosp.revcat }}
	        </div>
	      </div>
	    </div>
	    <!-- Rural Health Clinic -->
	    <div class="row">
	      <div class="col-sm-6 text-right">
	        <strong>Rural Health Clinic:</strong>
	      </div>
	      <div class="col-sm-6">
	        <div class="col-sm-6" v-if="myhosp.hasrhc == ''">
	          <span class="missingdata">MISSING DATA</span>
	        </div>
	        <div v-else>
	          {{ myhosp.hasrhc }}
	        </div>
	      </div>
	    </div>
	    <!-- Long-Term Care -->
	    <div class="row">
	      <div class="col-sm-6 text-right">
	        <strong>Long-Term Care:</strong>
	      </div>
	      <div class="col-sm-6">
	        <div class="col-sm-6" v-if="myhosp.hassnf == ''">
	          <span class="missingdata">MISSING DATA</span>
	        </div>
	        <div v-else>
	          {{ myhosp.hassnf }}
	        </div>
	      </div>
	    </div>
	    <!-- Government Owned -->
		<div class="row">
			<div class="col-sm-6 text-right">
				<strong>Government Owned:</strong>
			</div>
			<div class="col-sm-6">
				<div class="col-sm-6" v-if="myhosp.govt == ''">
					<span class="missingdata">MISSING DATA</span>
				</div>
				<div v-else>
				  {{ myhosp.govt }}
				</div>
			</div>
		</div>
		
	    <br/>
	    <div class="row">
	      <!-- Rev Cat Icon -->
	      <div class="col-sm-3">
	        <div v-if="myhosp.revcat == 'Under 10m'">
	          <a href="#"><img src="images/revmin.png" onmouseover="this.src='images/revmin_alt.png'" onmouseout="this.src='/images/revmin.png'" height="48"/></a>
	        </div>
	        <div v-else-if="myhosp.revcat == '10-20m'">
	          <a href="#"><img src="images/revmid.png" onmouseover="this.src='images/revmid_alt.png'" onmouseout="this.src='/images/revmid.png'" height="48"/></a>
	        </div>
	        <div v-else-if="myhosp.revcat == 'Over 20m'">
	          <a href="#"><img src="images/revmax.png" onmouseover="this.src='images/revmax_alt.png'" onmouseout="this.src='/images/revmax.png'" height="48"/></a>
	        </div>
	      </div>
	      <!-- Rural Icon -->
	      <div class="col-sm-3">
	        <div v-if="myhosp.hasrhc == 'Has RHC'">
	          <!-- <img src="images/rural.png" alt="Has Rural Health Clinic" height="48"/> -->
	          <a href="#"><img src="images/rural.png" onmouseover="this.src='images/has_rhc.png'" onmouseout="this.src='/images/rural.png'" height="48"/></a>
	        </div>
	        <div v-else>
	          <!-- <img src="images/rural_gray.png" alt="No Rural Health Clinic" height="48"/> -->
	          <a href="#"><img src="images/rural_gray.png" onmouseover="this.src='images/no_rhc.png'" onmouseout="this.src='/images/rural_gray.png'" height="48"/></a>
	        </div>
	      </div>
	      <!-- LTC icon -->
	      <div class="col-sm-3">
	        <div v-if="myhosp.hassnf == 'Has LTC'">
	          <!-- <img src="images/ltc.png" alt="Has Long Term Care Facility" height="48" /> -->
	          <a href="#"><img src="images/ltc.png" onmouseover="this.src='images/has_ltc.png'" onmouseout="this.src='/images/ltc.png'" height="48"/></a>
	        </div>
	        <div v-else>
	          <!-- <img src="images/ltc_gray.png" alt="No Long Term Care Facility" height="48" /> -->
	          <a href="#"><img src="images/ltc_gray.png" onmouseover="this.src='images/no_ltc.png'" onmouseout="this.src='/images/ltc_gray.png'" height="48"/></a>
	        </div>
	      </div>
	      <!-- govt icon -->
	      <div class="col-sm-3">
	        <div v-if="myhosp.govt == 'Govt'">
	          <!-- <img src="images/govt.png" alt="Government Owned" height="48" /> -->
	          <a href="#"><img src="images/govt.png" onmouseover="this.src='images/govt_owned.png'" onmouseout="this.src='/images/govt.png'" height="48"/></a>
	        </div>
	        <div v-else>
	          <!-- <img src="images/govt_gray.png" alt="Not Government Owned" height="48" /> -->
	          <a href="#"><img src="images/govt_gray.png" onmouseover="this.src='images/not_govt.png'" onmouseout="this.src='/images/govt_gray.png'" height="48"/></a>
	        </div>
	      </div>
	    </div>
	    </div>
	</div>
</template>

<script type="module">

</script>

<script setup>
import { defineEmits, ref, defineExpose, onMounted } from "vue";  
//const emit = defineEmits(["passGroupData"]); 
let props = defineProps([  'defaultYear', 'user', 'showyear'])
//const myhosp = props.user.hospitals.pop();
var myhosp_year = ref(parseInt(props.defaultYear));
// var foundHospital =  props.user.hospitals.find(h => h.year == props.myhosp_year) 
// if (foundHospital == null) {
// 	console.log("getting latest")
// 	foundHospital = props.user.hospitals.at(-1)
// }
var myhosp = ref();

const years = props.user.hospitals.map(h => h.year);

var updateMyHosp = () => { 
	myhosp.value = findMyHosp();
}

var findMyHosp = () => { 
	console.log(myhosp_year.value)
  var foundHospital =  props.user.hospitals.find(h => h.year == myhosp_year.value) 
	if (foundHospital == null) {
		console.log("getting latest")
		foundHospital = props.user.hospitals.at(-1)
	}
	return foundHospital;
}


updateMyHosp();



defineExpose({  
  myhosp_year , myhosp 
});

</script>